import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles"
import VideoHubApp from './VideoHubApp'


const theme = createMuiTheme({
  breakpoints: {
    keys: ["sm", "md", "lg"],
    values: { sm: 0, md: 720, lg: 1080 }
  }
});

function App() {
  return (
    <MuiThemeProvider theme={theme}>
      <VideoHubApp />
    </MuiThemeProvider>
  );
}

export default App;
